module.exports = __webpack_public_path__ + "static/media/sell_finish_service_make_6.68250a20.jpg";